import { siteApiSlice } from "../../../app/siteApiSlice";
import { CourseStatus } from "../../courses/coursesApiSlice";
import { DraftStatus } from "../writingApiSlice";

export interface UserDraftHistory {
	formalFullName: string;
	essaysByCourse: UserDraftHistoryByCourse[];
}

export interface UserDraftHistoryByCourse {
	courseId: number;
	courseName: string;
	courseStatus: CourseStatus;
	createDate: Date;
	essays: UserDraftHistoryEssay[];
}

export interface UserDraftHistoryEssay {
	id: number;
	promptTitle: string;
	lastUpdateDate?: Date;
	lastDraftStatus: DraftStatus;
	lastDraftStatusDescription: string;
	drafts: UserDraftHistoryDraft[];
}

export interface UserDraftHistoryDraft {
	id: number;
	createDate: Date;
	lastUpdateDate: Date;
	draftStatus: DraftStatus;
	draftStatusDescription: string;
	draftTitle: string;
}

export interface UserViewDraftHistories {
	draftHistories: DraftHistory[];
}

export interface DraftHistory {
	id: number;
	length: number;
	status: string;
	statusDescription: string;
	savedOn: Date | null;
}

export interface DraftHistoryContent {
	format: string;
	content: string;
	markup: string;
}

export const draftAutosaveHistoryApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		viewDraftsForUser: build.query<UserDraftHistory, { writerId: number; courseId?: number }>({
			query: ({ writerId, courseId }) => ({
				url: `/User/ViewDraftsForUser`,
				params: { writerId, courseId },
			}),
			providesTags: ["WritingHistory"],
		}),
		viewDraftHistories: build.query<UserViewDraftHistories, { draftId: number }>({
			query: ({ draftId }) => ({
				url: `/User/ViewDraftHistories?id=${draftId}`,
			}),
			providesTags: ["WritingHistory"],
		}),
		draftHistoryContent: build.query<DraftHistoryContent, { historyId: number }>({
			query: ({ historyId }) => ({
				url: `/User/DraftHistory?id=${historyId}`,
				method: "POST",
			}),
			providesTags: ["WritingHistory"],
		}),
	}),
});

export const {
	useViewDraftsForUserQuery,
	useViewDraftHistoriesQuery,
	useDraftHistoryContentQuery,
} = draftAutosaveHistoryApiSlice;
